module.exports = __webpack_public_path__ + "img/bg_calc.32820d63.png";